<template>
    <v-row dense class="">
        <v-col cols="10" class="">
            <v-row justify="center">
                <h5>個人情報の取扱いに関する覚書</h5>
            </v-row>
            <hr class="dashed my-1">
            <v-row dense no-gutter justify="center" class="mx-1">
                <v-col cols="6" class="">
                    <v-row justify="center" align="center">
                        <span class="caption mx-1">送信済み</span>
                        <v-checkbox v-model="ctpdStatus.sent"></v-checkbox>
                    </v-row>
                </v-col>
                <v-col cols="6">
                    <v-row justify="center" align="center">
                        <span class="caption mx-1">契約済み</span>
                        <v-checkbox v-model="ctpdStatus.signed"></v-checkbox>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="2" class="">
            <v-row justify="center">
                <h5>覚書作成</h5>
            </v-row>
            <hr class="dashed my-1">
            <v-row justify="center" align="center">
                <v-col cols="12">
                    <v-row justify="center">
                        <v-btn x-small class="mt-3" @click="downloadCTPD()">PDFを作成</v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
/* eslint-disable no-console */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
    name:'ctpd',
    props:[
        'researcher',
    ],
    data(){
        return{
            ctpdStatus:{
                sent:false,
                signed:false,
            }
        }
    },
    methods:{
        downloadCTPD(){
            pdfMake.fonts = {
                GenShin: {
                    normal: 'GenShinGothic-Normal-Sub.ttf',
                    bold: 'GenShinGothic-Normal-Sub.ttf',
                    italics: 'GenShinGothic-Normal-Sub.ttf',
                    bolditalics: 'GenShinGothic-Normal-Sub.ttf',
                },
            };
            const defaultStyle = 'GenShin';

            // PDF出力する内容の定義
            const dateOfCreation = new Date();
            const docDefinition = {
                content: [
                    {
                        text: '個人情報の取扱いに関する覚書',
                        style: 'header',
                        alignment: 'center'
                    },
                    {
                        text: '(業務委託個人事業主様用)',
                        style: 'text',
                        alignment: 'center'
                    },
                    {
                        text: `委託者 株式会社ＴＰＯ(以下、甲という)と受託者${this.researcher.name[1]+' '+this.researcher.name[0]}(以下、乙という)とは、個人情報の取扱いに関する以下の条項に関して、覚書を取り交わす。`,
                        style: 'text',
                        margin:[0,15,0,15],
                        alignment: 'start'
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第1条(目的)',
                                {   
                                    type:'none',
                                    ol:[
                                        '本覚書は、委託業務(〇〇〇〇業務)の履行に関して、乙が、甲から委託を受けた個人情報の機密を守り、安全に管理するために遵守すべき事項を定める。'
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第2条(対象個人情報)',
                                {   
                                    type:'none',
                                    ol:[
                                        '本覚書は、委託業務を履行するために、乙が甲から委託を受けた個人情報を対象とする。'
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第3条(責任)',
                                {   
                                    type:'none',
                                    ol:[
                                        '甲は乙に対し、委託業務を履行するために必要かつ十分な個人情報を、適切な方法で提供する責任を負う。',
                                        '2. 甲は乙に対し、委託した個人情報の管理及び取扱いに関して、具体的な手順及び方法を示す責任を負う。',
                                        '3. 乙は、甲から委託を受けた個人情報を使用して委託業務を確実に履行するとともに、当該個人情報の機密保持・安全管理に努める責任を負う。'
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第4条(安全管理)',
                                {   
                                    type:'none',
                                    ol:[
                                        '乙は、甲から委託された個人情報の機密保持及び安全管理のために、次の各号に掲げる行為をしてはならない。',
                                        {
                                            ol:[
                                                '個人情報を、乙の担当者もしくは甲の承諾を得て第三者に再委託した場合のその担当者以外の第三者に開示すること。',
                                                '個人情報を、甲の承諾なしに委託業務を履行する以外の目的に使用すること。',
                                                '個人情報を、甲の承諾なしに所定の場所より持ち出すこと。',
                                                '個人情報を、甲の承諾なしに複製すること。',
                                                '個人情報を、甲の承諾なしに廃棄又は残置すること。',
                                            ]
                                        }
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第5条(保管場所)',
                                {   
                                    type:'none',
                                    ol:[
                                        '乙は、甲から委託された個人情報を記録した書類その他物件（以下、合わせて物件という）を、乙又は乙の許可された従業員だけが立ち入ることのできる場所に設置された施錠のできる保管施設（以下、合わせて保管場所という）に保管する。'
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第6条(従業員の監督)',
                                {   
                                    type:'none',
                                    ol:[
                                        '乙は、乙の従業者に対して本覚書に定める事項を順守するよう教育し、個人情報の機密保持と安全管理について徹底する。'
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第7条(取扱い状況の報告)',
                                {   
                                    type:'none',
                                    ol:[
                                        '乙は、甲から求められた場合、委託された個人情報の件数の増減、管理状況などについて、書面で報告する。'
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第8条(再委託)',
                                {   
                                    type:'none',
                                    ol:[
                                        '乙は、甲の承諾なく委託業務を履行するための業務のうち個人情報を取り扱う業務を、第三者に再委託することはできない。',
                                        '2. 乙は、個人情報を取り扱う業務を再委託する場合、再委託業務の内容、業務に関与する担当者の氏名、経歴等の甲が要求する事項を事前に書面で甲に通知し、甲の承諾を得る。'
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第9条(事故発生時の連絡)',
                                {   
                                    type:'none',
                                    ol:[
                                        '乙の施設内において甲から委託された個人情報に係る事故が発生した場合、乙は速やかにそのことを甲に連絡し、対応についての指示を受ける。',
                                        '2. 事故に対する対応がすべて終了した後、乙は事故の発生状況、被害状況、発生原因、再発防止策を書面にまとめ、甲に報告する。'
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第10条(個人情報の返却又は廃棄)',
                                {   
                                    type:'none',
                                    ol:[
                                        '乙は、委託業務に基づく業務が終了した場合、甲から提供を受けた物件をすべて返却する。',
                                        '2. 乙は甲の要求により物件を廃棄した場合は、甲の指示する方法で廃棄し、廃棄した旨の証明書を甲に提出する。'
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第11条(現地検査)',
                                {   
                                    type:'none',
                                    ol:[
                                        '甲は、乙に委託した個人情報の管理及び取扱い状況を確認するために、事前に乙に通知したうえで、委託した個人情報を管理している乙の施設での調査ができるものとする。',
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第12条(損害賠償)',
                                {   
                                    type:'none',
                                    ol:[
                                        '乙が本覚書で定めた事項を遵守せず、甲から委託された個人情報に係る事故を発生させた場合、甲は乙に対して、被害の大きさに応じて損害賠償を要求することがある。',
                                    ]
                                }
                            ],

                        ]
                    },
                    {   
                        type:'none',
                        margin:[0,10,0,10],
                        ol:[    
                           
                            [
                                '第13条(相互協力)',
                                {   
                                    type:'none',
                                    ol:[
                                        '甲と乙は、本覚書で定めた事項を遵守し、協力して個人情報の機密保持と安全管理に努めるともに、委託業務を確実に履行する。',
                                        '2. 本覚書で定めていない事象が発生した場合、甲と乙は誠意をもって対応策を協議し、実施する。',
                                    ]
                                }
                            ],

                        ]
                    },
                    {
                        text: '以上、本覚書は２通作成し、甲乙各１通を保有する。',
                        style: 'text',
                        margin:[10,15,0,15],
                        alignment: 'start'
                    },
                    {
                        text: `日付${''+''+''+''+''+dateOfCreation.getFullYear()}年${dateOfCreation.getMonth()+1}月${dateOfCreation.getDate()}日`,
                        style: 'text',
                        margin:[5,10,0,10],
                        alignment: 'start'
                    },
                    {
                        text: `委託者(甲)    東京都港区六本木6-6-2           受託者(乙)   住所     ${this.researcher.address.address}`,
                        style: 'text',
                        margin:[10,15,0,15],
                        alignment: 'start'
                    },
                    {
                        text:'株式会社ＴＰＯ',
                        style: 'text',
                        margin:[80,15,0,15],
                        alignment: 'start'
                    },
                    {
                        text: `代表取締役 マニヤン 麻里子                       氏名     ${this.researcher.name[1]+' '+this.researcher.name[0]}`,
                        style: 'text',
                        margin:[80,15,0,15],
                        alignment: 'start'
                    },

                ],
                defaultStyle: {
                    font: defaultStyle,
                },
                styles: {
                    header: {
                        fontSize: 18,
                    },
                    subheader: {
                        fontSize: 10.5,
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                },
            }
            pdfMake.createPdf(docDefinition).open();
        },
    },
}
</script>
